    // src/redux/slices/authSlice.js
    import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
    import axios from "axios";
    import { ApiBaseUrl, professionalLogout } from "../../Utils/Constants";
    import { showToast } from "../../Helper/Toast";

    export const hitLogoutProfessionalApi = createAsyncThunk("hitLogoutProfessionalApi", async () => {
      try {
        const config = {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            Authorization: `${localStorage.getItem("professionalToken")}`,
          },
        };
        const url = ApiBaseUrl + professionalLogout;
        const response = await axios.put(url, {}, config);
        return response.data;
      } catch (error) {
        showToast(error.response.data.message, "error");
        throw error.response.data;
      }
    });
    
    const LogoutProfessionalSlice = createSlice({
      name: "logoutProfessionalReducer",
      initialState: {
        isLoading: false,
        data: null,
      },
      reducers: {
        clearhitLogoutProfessionalData: (state) => {
          state.data = null;
        },
      },
      extraReducers: (builder) => {
        builder
          .addCase(hitLogoutProfessionalApi.pending, (state) => {
            state.isLoading = true;
          })
          .addCase(hitLogoutProfessionalApi.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
          })
          .addCase(hitLogoutProfessionalApi.rejected, (state) => {
            state.isError = false;
          });
      },
    });

    export const { clearhitLogoutProfessionalData } = LogoutProfessionalSlice.actions;
    export default LogoutProfessionalSlice.reducer;
    